import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "input"]

  debounce() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      if (this.inputTarget.value.length >= 2) {
        this.formTarget.requestSubmit()
      }
    }, 300)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
